// extracted by mini-css-extract-plugin
export default {"revelar":"Revelar_revelar__E1n0H","visivel":"Revelar_visivel__ALwUx"};